import { Observable } from 'rxjs';
import Axios from 'axios-observable';

const Domain = process.env.REACT_APP_MAIN_API_SERVER;

class ThemesFull {
    mapData(data) {
        return data.map(item => {
            if (item.children && item.children.length) {
                item.children = this.mapData(item.children);
            }
            return { ...item, title: item.name, value: item.id };
        })
    }

    get() {
        return new Observable(subscriber => {
            Axios.get(Domain + '/themes/?full=true').subscribe(resp => {
                const data = this.mapData(resp.data.themes);
                subscriber.next(data);
                subscriber.complete();
            });
        })
    }
}
export default new ThemesFull();